import * as React from "react"
import { MerlinStatus } from "@gatsbyjs/graphql"
import { CrossIcon, LayersIcon } from "gatsby-ui/src/components/icons"
import { CheckIcon } from "gatsby-interface"
import { SpinnerLight } from "gatsby-ui/src/components"

export const formattedStatus: {
  [key: string]: string
} = {
  [MerlinStatus.Failed]: `Error`,
  [MerlinStatus.InProgress]: `Updating`,
  [MerlinStatus.Pending]: `Pending`,
  [MerlinStatus.Success]: `Success`,
  [MerlinStatus.Idle]: `Idle`,
}

export const statusIcons: {
  [key: string]: JSX.Element | null
} = {
  [MerlinStatus.Failed]: <CrossIcon />,
  [MerlinStatus.Success]: <CheckIcon />,
  [MerlinStatus.Pending]: <LayersIcon />,
  [MerlinStatus.InProgress]: <SpinnerLight />,
  [MerlinStatus.Idle]: null,
}
